import { Component, AfterContentInit, isDevMode } from '@angular/core';
import { FarmService } from '../../services/farm.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../services/dialog.service';
import { AdminService } from 'src/app/services/admin.service';

@Component({
    selector: 'app-farm-list',
    templateUrl: './farm-list.component.html',
    styleUrls: ['./farm-list.component.css'],
    providers: [AdminService, FarmService],
    standalone: false
})
export class FarmListComponent implements AfterContentInit {
  gridData: any = [];

  constructor(
    private adminApi: AdminService,
    private farmApi: FarmService,
    private dialog: DialogService,
    private toastr: ToastrService
  ) {}

  yesNoDialog(ext_id: string) {
    this.dialog
      .confirmDialog({
        title: 'Are you sure?',
        message: 'Are you sure you want to delete the farm ?',
        confirmCaption: 'Yes',
        cancelCaption: 'No',
      })
      .subscribe((yes) => {
        let entity = 'farm';
        let parameters = `?entity=${entity}&ext_id=${ext_id}`;
        if (yes) {

          this.adminApi.delete(parameters).subscribe(
            (s) => {

              if (s.body.includes('successfully')) {
                this.toastr.success(s.body);
                this.ngAfterContentInit();
              } else if (s.body.errorMessage) {
                this.toastr.error(
                  `Error deleting the farm. Error: ${s.errorMessage}`
                );
              } else {
                this.toastr.error(`Error deleting the farm. Error: ${s.body}`);
              }
            },
            (error) => this.toastr.error(error.error.errorMessage)
          );
        }
      });
  }

  loadItems(): any {
    this.gridData = [];
    this.farmApi.getAll().subscribe((l) => {
      if (l.body) {
        this.gridData = l.body.filter((obj: any) => obj.status == 'ACTIVE');
      }
    });
  }

  ngAfterContentInit(): void {
    this.loadItems();
  }
}
